export const GET_INIT_DATA_TODO = "GET_INIT_DATA_TODO";
export const ADD_TODO = "ADD_TODO";
export const DELETE_TODO = "DELETE_TODO";
export const UPDATE_UNDONE_TODO = "UPDATE_UNDONE_TODO";
export const UPDATE_DONE_TODO = "UPDATE_DONE_TODO";
export const ACTION_DONE_TODO = "ACTION_DONE_TODO";
export const ACTION_UNDONE_TODO = "ACTION_UNDONE_TODO";
export const LOADING = "LOADING";
export const ERROR = "ERROR";
